<template>
    <transition name="animate">
        <div class="common-search" v-show="visible">
            <form action="/">
                <van-search
                    v-model="value"
                    show-action
                    autofocus
                    shape="round"
                    background="#FEFEFE"
                    placeholder="请输入您想找的宝贝名称"
                    @search="onSearch"
                    @cancel="onCancel"
                />
            </form>
            <div class="common-search-hd">
                <span class="search-hd-font">搜索历史</span>
                <img src="~img/common/lajitong.png" class="search-hd-img" alt="" @click="deleteHistory">
            </div>
            <div class="common-search-bd">
                <div class="search-bd-item" v-for="(item, index) in historyList" :key="index" @click="$router.push('/searchResult?params='+item+'&&businessProperty='+businessProperty)">{{item}}</div>
            </div>
        </div>
    </transition>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            value: '',
            visible: false
        };
    },
    props: {
        businessProperty: Number
    },
    computed: {
        ...mapState('searchResult', {
            historyList: 'historyList'
        })
    },
    watch: {
        visible() {
            if(this.visible) {
                this.getHistoryList();
            }
        }
    },
    methods: {
        ...mapActions('searchResult', {
            getHistoryList: 'getHistoryListAction',
            addHistory: 'addHistoryAction',
            deleteHistory: 'deleteHistoryAction',
            setSearchParams: 'setSearchParamsAction'
        }),
        onSearch(value) {
            this.addHistory({ history: value });
            this.$router.push('/searchResult?params=' + value+'&&businessProperty='+this.businessProperty);
        },
        onCancel() {
            this.value = '';
            this.visible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.common-search {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background-color: #FEFEFE;

    .van-search__action {
        color: #919191;
        font-size: 15px;
        padding: 0 15px;
    }
    .common-search-hd {
        display: flex;
        padding: 0 15px;
        margin-top: 11px;
        line-height: 20px;
        justify-content: space-between;

        .search-hd-font {
            font-size: 15px;
            color: #333333;
            font-weight: bold;
            vertical-align: middle;
        }
        .search-hd-img {
            height: 15px;
            vertical-align: middle;
        }
    }
    .common-search-bd {
        margin-top: 10px;
        padding: 0 15px;

        .search-bd-item {
            padding: 0 10px;
            height: 29px;
            line-height: 29px;
            box-sizing: border-box;
            background-color: #F6F6F6;
            border-radius: 15px;
            color: #585858;
            font-size: 15px;
            margin-right: 10px;
            margin-bottom: 10px;
            float: left;
        }
    }
}
</style>